import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Phone, Mail, Globe, Lock } from 'lucide-react';
import { toast, Toaster } from 'sonner';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      toast.success('Request submitted successfully. We will contact you shortly.', {
        style: {
          background: '#111827',
          color: '#fff',
          border: '1px solid #C9A84C'
        }
      });
      (e.target as HTMLFormElement).reset();
    }, 1000);
  };
  return <section id="contact" className="py-24 bg-navy relative border-b border-white/5" data-id="element-75" data-mp="3f48iwu5ubp54">
      <Toaster position="bottom-right" data-id="element-76" data-mp="gifcywpk8b46" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77" data-mp="bpcjspop33oi">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-78" data-mp="bnrogxuk3gpl">
          {/* Left Column: Info */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col justify-center" data-id="element-79" data-mp="3jxxi0w29t4yg">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6 uppercase" data-id="element-80" data-mp="314k320eyd94h">
              Ready to Move <br data-id="element-81" data-mp="3657rqffpldvj" />
              <span className="text-gold" data-id="element-82" data-mp="365rc02su0ecq">Critical Cargo?</span>
            </h2>

            <div className="space-y-4 mb-10" data-id="element-83" data-mp="2s5gies050lnv">
              {['Free Quote', '24/7 Dispatch Available', 'Fully Insured', 'Nationwide Coverage'].map((item, idx) => <div key={idx} className="flex items-center" data-id="element-84" data-mp="qb7jgppg098n" data-mpi={idx}>
                  <CheckCircle2 className="w-6 h-6 text-gold mr-3" data-id="element-85" data-mp="udc634hh45ls" />
                  <span className="text-lg text-slate-300 font-medium" data-id="element-86" data-mp="23c3q7pdkj5dn">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="bg-navy-light rounded-2xl p-8 border border-white/5 space-y-6" data-id="element-87" data-mp="1uavyjq5k52sj">
              <a href="tel:+17862620064" className="flex items-center group" data-id="element-88" data-mp="1pbsvucd1v8nq">
                <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center mr-4 border border-white/10 group-hover:border-gold/50 transition-colors" data-id="element-89" data-mp="1pdvvzp7x2i66">
                  <Phone className="w-5 h-5 text-gold" data-id="element-90" data-mp="2i1rn8eepvhvk" />
                </div>
                <div data-id="element-91" data-mp="2d8yivrn5ubk0">
                  <span className="block text-sm text-slate-400 uppercase tracking-wider mb-1" data-id="element-92" data-mp="2d8gol0k267eq">
                    24/7 Phone
                  </span>
                  <span className="text-white font-heading text-xl tracking-wide group-hover:text-gold transition-colors" data-id="element-93" data-mp="35pssneglmi6r">
                    +1 786-262-0064
                  </span>
                </div>
              </a>

              <a href="mailto:dispatch@jetforceaviation.com" className="flex items-center group" data-id="element-94" data-mp="38bacgkbxn6us">
                <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center mr-4 border border-white/10 group-hover:border-gold/50 transition-colors" data-id="element-95" data-mp="3dbo9l7bzwwe1">
                  <Mail className="w-5 h-5 text-gold" data-id="element-96" data-mp="3mb1j2004dkyr" />
                </div>
                <div data-id="element-97" data-mp="3ra4r7tbec7ay">
                  <span className="block text-sm text-slate-400 uppercase tracking-wider mb-1" data-id="element-98" data-mp="3r8jwa2l66mck">
                    Dispatch Email
                  </span>
                  <span className="text-white text-base group-hover:text-gold transition-colors break-all" data-id="element-99" data-mp="4u0jgabuff87">
                    dispatch@jetforceaviation.com
                  </span>
                </div>
              </a>

              <a href="mailto:operations@jetforceaviation.com" className="flex items-center group" data-id="element-100" data-mp="dv859sx6anle">
                <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center mr-4 border border-white/10 group-hover:border-gold/50 transition-colors" data-id="element-101" data-mp="irgrtrdp9j2l">
                  <Mail className="w-5 h-5 text-gold" data-id="element-102" data-mp="14ft8gzbuqva" />
                </div>
                <div data-id="element-103" data-mp="ewvt58wxm8rz">
                  <span className="block text-sm text-slate-400 uppercase tracking-wider mb-1" data-id="element-104" data-mp="ew47apt4zpew">
                    Operations Email
                  </span>
                  <span className="text-white text-base group-hover:text-gold transition-colors break-all" data-id="element-105" data-mp="3ict43k2x3krd">
                    operations@jetforceaviation.com
                  </span>
                </div>
              </a>

              <a href="https://jetforceaviation.com" target="_blank" rel="noopener noreferrer" className="flex items-center group" data-id="element-106" data-mp="3scjxtjjnlvqe">
                <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center mr-4 border border-white/10 group-hover:border-gold/50 transition-colors" data-id="element-107" data-mp="17k04rwqj5lcq">
                  <Globe className="w-5 h-5 text-gold" data-id="element-108" data-mp="2kjk1nkuph85m" />
                </div>
                <div data-id="element-109" data-mp="2pioa299t31uw">
                  <span className="block text-sm text-slate-400 uppercase tracking-wider mb-1" data-id="element-110" data-mp="2pj6dpqyssicu">
                    Website
                  </span>
                  <span className="text-white text-base group-hover:text-gold transition-colors" data-id="element-111" data-mp="2bl840yvf9a3o">
                    jetforceaviation.com
                  </span>
                </div>
              </a>
            </div>
          </motion.div>

          {/* Right Column: Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-112" data-mp="388wa2ii7lc6v">
            <div className="bg-navy-light rounded-3xl p-8 md:p-10 border border-white/10 shadow-2xl relative overflow-hidden" data-id="element-113" data-mp="3n6ey1in2bld9">
              <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-[80px] -mr-20 -mt-20 pointer-events-none" data-id="element-114" data-mp="3ryy6y2at1sbq"></div>

              <h3 className="text-2xl font-heading font-bold text-white mb-6 uppercase" data-id="element-115" data-mp="owlqxna44uq">
                Request a Quote
              </h3>

              <form onSubmit={handleSubmit} className="space-y-5 relative z-10" data-id="element-116" data-mp="3rtwfwl3jrhqq">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-117" data-mp="3mww9ua6p6ezm">
                  <div data-id="element-118" data-mp="3iuj4vnzryl3w">
                    <label htmlFor="name" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-119" data-mp="3iurhrfvwdqf3">
                      Full Name *
                    </label>
                    <input required type="text" id="name" className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors" placeholder="John Doe" data-id="element-120" data-mp="3957wy4omjmhl" />
                  </div>
                  <div data-id="element-121" data-mp="1ammohdhgwpwu">
                    <label htmlFor="company" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-122" data-mp="1ap8xlhk0bdh6">
                      Company Name
                    </label>
                    <input type="text" id="company" className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors" placeholder="Aviation Co." data-id="element-123" data-mp="1omxhon692gl6" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-124" data-mp="15ouwykkqj5t6">
                  <div data-id="element-125" data-mp="88p3bfvmvdkm">
                    <label htmlFor="phone" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-126" data-mp="87e29ntkojx7">
                      Phone Number *
                    </label>
                    <input required type="tel" id="phone" className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors" placeholder="+1 (555) 000-0000" data-id="element-127" data-mp="32pu6y3p355we" />
                  </div>
                  <div data-id="element-128" data-mp="3lm3jgmkc9oea">
                    <label htmlFor="email" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-129" data-mp="3gpv87k99ifce">
                      Email Address *
                    </label>
                    <input required type="email" id="email" className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors" placeholder="john@example.com" data-id="element-130" data-mp="3qgg2wwltezq1" />
                  </div>
                </div>

                <div data-id="element-131" data-mp="rszamwuexwep">
                  <label htmlFor="service" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-132" data-mp="cykoinfjy6vt">
                    Service Type *
                  </label>
                  <select required id="service" className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors appearance-none" data-id="element-133" data-mp="44pry3shxors">
                    <option value="" data-id="element-134" data-mp="3vck47c4b2ae1">Select a service...</option>
                    <option value="transport" data-id="element-135" data-mp="3hc102g2ynoh5">Aviation Transport</option>
                    <option value="line_maintenance" data-id="element-136" data-mp="3lduwuda1c8c1">
                      A&P Line Maintenance
                    </option>
                    <option value="100_hour" data-id="element-137" data-mp="3iptgy1aphjei">100 Hour Inspection</option>
                    <option value="interior_clean" data-id="element-138" data-mp="3np646n5hoshm">
                      Aircraft Interior Cleaning
                    </option>
                    <option value="exterior_wash" data-id="element-139" data-mp="39q6gpitpqjn1">
                      Aircraft Exterior Dry Wash
                    </option>
                    <option value="aog" data-id="element-140" data-mp="3dri55l0uoytn">AOG Support</option>
                    <option value="custom" data-id="element-141" data-mp="5aoiwb86oyet">Custom Quote</option>
                  </select>
                </div>

                <div data-id="element-142" data-mp="a983o8b1k45l">
                  <label htmlFor="description" className="block text-sm font-medium text-slate-400 mb-1.5" data-id="element-143" data-mp="a9robws2t6nb">
                    Description of Need *
                  </label>
                  <textarea required id="description" rows={4} className="w-full bg-navy border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-gold/50 focus:ring-1 focus:ring-gold/50 transition-colors resize-none" placeholder="Please provide details about your cargo, aircraft, location, and timeline..." data-id="element-144" data-mp="oa2esyph4j7y"></textarea>
                </div>

                <div data-id="element-145" data-mp="2nitxu67ygr4f">
                  <label className="block text-sm font-medium text-slate-400 mb-2" data-id="element-146" data-mp="2ii69jsb42odw">
                    Preferred Contact Method
                  </label>
                  <div className="flex gap-4" data-id="element-147" data-mp="1uskar5ynib6f">
                    <label className="flex items-center cursor-pointer" data-id="element-148" data-mp="1ptqvb7zt0a3m">
                      <input type="radio" name="contact_method" value="phone" className="w-4 h-4 text-gold bg-navy border-white/10 focus:ring-gold focus:ring-offset-navy" defaultChecked data-id="element-149" data-mp="1pvliyu2gmgbe" />
                      <span className="ml-2 text-sm text-slate-300" data-id="element-150" data-mp="3b73eyuu84qp8">Phone</span>
                    </label>
                    <label className="flex items-center cursor-pointer" data-id="element-151" data-mp="3iajmz62inc2r">
                      <input type="radio" name="contact_method" value="email" className="w-4 h-4 text-gold bg-navy border-white/10 focus:ring-gold focus:ring-offset-navy" data-id="element-152" data-mp="3n8v13szug8qs" />
                      <span className="ml-2 text-sm text-slate-300" data-id="element-153" data-mp="2zjaen04hetcr">Email</span>
                    </label>
                    <label className="flex items-center cursor-pointer" data-id="element-154" data-mp="34idb3w6ebr94">
                      <input type="radio" name="contact_method" value="whatsapp" className="w-4 h-4 text-gold bg-navy border-white/10 focus:ring-gold focus:ring-offset-navy" data-id="element-155" data-mp="34g98dhk8gyaf" />
                      <span className="ml-2 text-sm text-slate-300" data-id="element-156" data-mp="2gsizfhxtc8qg">
                        WhatsApp
                      </span>
                    </label>
                  </div>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full bg-gold hover:bg-gold-light text-navy font-bold py-4 rounded-xl transition-all shadow-gold-glow hover:shadow-gold-glow-lg mt-4 flex items-center justify-center text-lg disabled:opacity-70" data-id="element-157" data-mp="12un9mge05td0">
                  {isSubmitting ? 'Submitting...' : 'Submit Request →'}
                </button>

                <div className="flex items-center justify-center mt-4 text-slate-500 text-xs" data-id="element-158" data-mp="f6naas2mkumt">
                  <Lock className="w-3 h-3 mr-1.5" data-id="element-159" data-mp="b520xgpauyhd" />
                  Your information is private and never shared.
                </div>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}